import type { ReactNode } from "react";
import { Pressable, StyleSheet, Text } from "react-native";

import {
  fonts,
  radii,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function ActiveNavButton({
  children,
  active,
  onPress,
}: {
  children: ReactNode;
  active: boolean;
  onPress: () => void;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <Pressable
      accessibilityRole="tab"
      accessibilityState={{ selected: active }}
      onPress={onPress}
      style={({ hovered, pressed }) => [
        stylesheet.button,
        active ? stylesheet.active : null,
        hovered || pressed ? stylesheet.hover : null,
      ]}
    >
      <Text style={[stylesheet.text, active ? stylesheet.activeText : null]}>
        {children}
      </Text>
    </Pressable>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    button: {
      minHeight: 40,
      justifyContent: "center",
      paddingHorizontal: spacing.m,
      paddingVertical: spacing.s,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: radii.s,
      backgroundColor: colors.elevated,
    },
    active: {
      borderColor: colors.primary,
      backgroundColor: colors.primary,
    },
    hover: { backgroundColor: colors.surface },
    text: {
      color: colors.foreground,
      fontFamily: fonts.medium,
      fontSize: 14,
    },
    activeText: { color: colors.primaryForeground },
  });
